import React from "react"

export default function Footer() {
  return (
    <div className="bg-black p-2 flex justify-center items-center font-bold text-white font-sen text-sm sm:text-base md:text:lg text-center mt-16">
      © 2022 Copyright: CineZen - All Rights Reserved
    </div>
  )
}
